import Reveal from '@/components/base/Reveal';
import { Link } from 'react-router-dom';

export default function Cta() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm border border-accent-200">
            感知 · 展示 · 连接
          </div>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            从硬件终端，到场景化整体方案
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            智慧城市产品可单独选型部署，也可结合县域与园区场景整体交付，支持项目集成、批量采购与定制开发。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/contact/business"
              className="px-8 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              立即咨询采购
            </Link>
            <Link
              to="/solutions"
              className="px-8 py-3 rounded-md border border-primary-400 text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-50"
            >
              查看解决方案
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}